enum IeBicValue {
  AIBKIE2D = 'AIBKIE2D',
  PSTSIE21 = 'PSTSIE21',
  BOFAIE3X = 'BOFAIE3X',
  BOFIIE2D = 'BOFIIE2D',
  BARCIE2D = 'BARCIE2D',
  BNPAIE2D = 'BNPAIE2D',
  IRCEIE2D = 'IRCEIE2D',
  CITIIE2X = 'CITIIE2X',
  DABAIE2D = 'DABAIE2D',
  EBSIIE2D = 'EBSIIE2D',
  USBKIE2D = 'USBKIE2D',
  HSBCIE2D = 'HSBCIE2D',
  INGBIE2D = 'INGBIE2D',
  BCITIE2D = 'BCITIE2D',
  CHASIE2X = 'CHASIE2X',
  ICONIE2D = 'ICONIE2D',
  IPBSIE2D = 'IPBSIE2D',
  CPAYIE2D = 'CPAYIE2D',
  ULSBIE2D = 'ULSBIE2D',
}

export default IeBicValue;
